import type { SaveCalendarViewConfig } from 'owa-save-calendar-view-data';
import { action } from 'satcheljs';

/**
 * Action invoked when user deletes a calendar saved view from Ribbon, Command bar, or hotkey
 *
 * @param savedView calendar saved view type
 */
export const deleteCalendarSavedView = action(
    'deleteCalendarSavedView',
    (savedView: SaveCalendarViewConfig, isErrorState: boolean) => ({ savedView, isErrorState })
);
